import cx from 'classnames';
import NextLink from 'next/link';

import {Button, Text} from '#component/base';
import {ActionPlanAdjustmentList} from '#component/partial/ActionPlanAdjustmentList';
import {sprinkles} from '#style/sprinkles';

import {ActionPlanRecommendationCardProps} from './ActionPlanRecommendationCard.types';

import * as css from './ActionPlanRecommendationCard.css';

/**
 * This card is used on the screen for a Health Factor assessment, and appears
 * if the assessment is part of the user's currently selected Action Plan.
 */
export const ActionPlanRecommendationCard = ({
  adjustment,
  className,
  ...otherProps
}: ActionPlanRecommendationCardProps) => {
  return (
    <div className={cx(css.root, className)} {...otherProps}>
      <div className={css.title}>
        <Text color="deepBurgundy" variant="heading3">
          This recommendation is part of your current Action Plan
        </Text>

        <ActionPlanAdjustmentList adjustments={adjustment ? [adjustment] : []} />
      </div>

      <NextLink href="/actionplan" passHref>
        <Button
          as="a"
          className={sprinkles({pos: 'relative', w: ['full', 'full', 'maxContent']})}
          icon="ArrowRight">
          View Action Plan
        </Button>
      </NextLink>
    </div>
  );
};
